import { cloneDeep } from 'lodash';
import { BeneficiaryEvent } from '/@/modules/beneficiary/constants/BeneficiaryEvent';

export const FormReadOnlyMixin = {
  props: {
    enableOnlyEmptyInput: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  events() {
    return {
      [BeneficiaryEvent.INVALIDATE_BENEFICIARY_DETAIL_CACHE]: this.cacheOriginalValue
    };
  },
  data() {
    return {
      originalValue: {}
    };
  },
  watch: {
    enableOnlyEmptyInput() {
      this.cacheOriginalValue();
    }
  },
  methods: {
    cacheOriginalValue() {
      this.originalValue = cloneDeep(this.value);
    },
    isReadOnlyInput(key, value) {
      return this.readOnly || (this.enableOnlyEmptyInput && !!(value ?? this.originalValue)?.[key]);
    }
  },
  created() {
    this.cacheOriginalValue();
  }
};
